import {Box, Button, Center, Flex, Icon, Text} from '@chakra-ui/react'
import BannerRevise from '@assets/images/learn/notebook_banner.png'
import {ReactComponent as ArrowRight4} from '@assets/svgs/learn/arrow_right_4.svg'
import {useLocation, useNavigate} from 'react-router-dom'
import {useEffect, useState} from 'react'
import reviseRequest from '@apis/revise'
import {PATH} from '@utils/Const'

const HeaderRevise = () => {
  const location = useLocation()
  const {entry_point} = location.state || {}
  const [quantities, setQuantities] = useState<any>()
  const navigate = useNavigate()

  useEffect(() => {
    getQuantities()
  }, [])
  const getQuantities = async () => {
    const res = await reviseRequest.getQuantities()
    if (res?.status === 200) {
      setQuantities(res.data.data)
    }
  }

  const handleClickBtn = () => {
    navigate(PATH.LEARN_REVISE_ROOM, {
      state: {entry_point},
    })
  }

  return (
    <Box
      minH={'400px'}
      bgImage={BannerRevise}
      bgRepeat={'no-repeat'}
      bgSize={'cover'}
      borderRadius={'0px 0px 100px 100px'}>
      <Flex
        flexDirection={{base: 'column', md: 'row'}}
        justifyContent={'space-between'}
        pt={{base: '32px', md: '54px'}}
        gap={'16px'}
        px={{base: '24px', md: '70px'}}>
        <Flex
          flexDirection={'column'}
          textAlign={{base: 'center', md: 'unset'}}
          color={'#002766'}>
          <Text fontSize={{base: '14px', md: '16px'}}>
            Theo mức độ ghi nhớ của bạn ...
          </Text>
          <Text fontSize={{base: '18px', md: '24px'}} fontWeight={600}>
            {`Có ${quantities?.phrase_quantity || 0} cụm từ cần ôn tập hôm nay`}
          </Text>
          <Text fontSize={{base: '14px', md: '16px'}} mt={'24px'}>
            Xem lại các cụm từ sau và bấm Bắt đầu khi sẵn sàng nhé!
          </Text>
        </Flex>
        <Center>
          <Button
            isDisabled={!quantities?.phrase_quantity}
            bg={'#FFA800'}
            borderRadius={'12px'}
            gap={'8px'}
            _hover={{bg: '#ffbb37'}}
            cursor={'pointer'}
            py={'24px'}
            onClick={handleClickBtn}>
            <Text fontSize={'16px'} color={'white'} fontWeight={700}>
              Bắt đầu học
            </Text>
            <Icon
              w={'24px'}
              h={'24px'}
              sx={{
                stroke: 'white',
              }}>
              <ArrowRight4 />
            </Icon>
          </Button>
        </Center>
      </Flex>
    </Box>
  )
}

export default HeaderRevise
